import React from 'react';
import { Container, Typography, Box, Paper, Button } from '@mui/material';
import { Download } from '@mui/icons-material';

// PDF file is in public/assets directory
const scientificSchedule = '/assets/Scientific Program Final for printing.pdf';

const Program = () => {

  return (
    <Container maxWidth="lg">
      <Box sx={{ py: 4 }}>
        <Paper elevation={0} sx={{ p: 4 }}>
          <Typography variant="h4" component="h1" gutterBottom align="center">
            Scientific Schedule
          </Typography>
          
          <Typography variant="subtitle1" paragraph align="center" color="text.secondary">
            Please refer to the detailed scientific schedule document below
          </Typography>

          <Box sx={{ 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center',
            mt: 4,
            gap: 3
          }}>
            {/* PDF Viewer */}
            <Box sx={{ 
              width: '100%', 
              maxWidth: '800px',
              height: '600px',
              border: '1px solid #e0e0e0',
              borderRadius: 2,
              overflow: 'hidden',
              boxShadow: 2
            }}>
              <iframe
                src={scientificSchedule}
                width="100%"
                height="100%"
                style={{ border: 'none' }}
                title="Scientific Schedule PDF"
              />
            </Box>

            {/* Download Button */}
            <Button
              variant="contained"
              color="primary"
              startIcon={<Download />}
              onClick={() => window.open(scientificSchedule, '_blank')}
              sx={{
                fontSize: '1.1rem',
                fontWeight: 'bold',
                py: 1.5,
                px: 3,
                borderRadius: 2,
                textTransform: 'none',
                boxShadow: 2,
                '&:hover': {
                  boxShadow: 4,
                  transform: 'translateY(-2px)',
                },
              }}
            >
              Download Scientific Schedule
            </Button>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default Program; 